<template>
  <div
    class="item-history-card"
    :data-qa="dataQa">
    <div
      class="item-history-card_header"
      :data-qa="dataQa + '-header'">
      <slot name="head">
        <div
          class="item-history-card_header-date"
          :data-qa="dataQa + '-date'">
          {{ historyDate }}
        </div>
        <UserIcon
          class="avatar"
          :data-qa="dataQa + '-avatar'"
          :name="item.contactName"
          size="35"/>
        <div
          class="item-history-card_header-name-event">
          <span
            class="item-history-card_header-name"
            :data-qa="dataQa + '-name'">
            {{ item.contactName }}
          </span>
          <span
            class="item-history-card_header-event"
            :data-qa="dataQa + '-event'">
            <slot name="eventType">
              {{ historyItemTitle }}
            </slot>
          </span>
        </div>
      </slot>
    </div>
    <div
      class="item-history-card_body"
      :data-qa="dataQa + '-body'">
      <slot name="body">
        <span class="item-history-card_body-content">
          <span
            v-if="item.reason"
            class="item-history-card_body-reason"
            :data-qa="dataQa + '-reason'">
            {{ item.reason }}
          </span>
          <slot name="parameters">
            <EventHistoryParams
              v-if="item.parameters"
              :data-qa="dataQa + '-parameters'"
              :spr="spr"
              :value="item"/>
          </slot></span>
      </slot>
      <slot name="body-after">
        <HistoryChangeState
          v-if="isShowStatuses"
          class="mt-2 item-history-card_body-states"
          :data-qa="dataQa + '-change-state'"
          :item="item"/>
      </slot>
    </div>
    <div
      class="item-history-card_footer"
      :data-qa="dataQa + '-footer'">
      <slot name="footer"/>
    </div>
  </div>
</template>
<script>
import UserIcon from 'components/header/UserIcon.vue'
import EventHistoryParams from 'components/common/blocks/history/components/EventHistoryParams.vue'
import HistoryChangeState from 'components/common/blocks/history/components/HistoryChangeState.vue'

import godModeMixin from 'mixins/godModeMixin'
import historyMixin from 'components/common/blocks/history/layout/historyMixin.js'

export default {
  name: 'LayoutHistoryItem',
  mixins: [ godModeMixin, historyMixin ],
  computed: {
    historyDate() {
      if (!this.item?.dateAdded) {
        return null
      }
      const historyDate = new Date(this.item.dateAdded)
      if (this.mixin_isGodMode) {
        return `${this.$d(historyDate, 'shortDate')} ${this.$d(historyDate, 'longTime')}.${historyDate.getMilliseconds()}`
      }
      return this.$d(historyDate, 'longDate')
    },
    isShowStatuses() {
      return (this.item?.prevTenderStatus || this.item?.newTenderStatus) && this.item?.prevTenderStatus?.id !== this.item?.newTenderStatus?.id
    },
  },
  components: {
    UserIcon,
    EventHistoryParams,
    HistoryChangeState,
  },
}
</script>
<style scoped lang="scss">
.item-history-card {
  container-type: inline-size;
  text-align: left;
  border-radius: 5px;
  padding: 5px;
  &_header {
    display: grid;
    grid-template-rows: auto auto;
    grid-template-columns: 36px 1fr;
    grid-gap: 8px;
    transition: all 0.3s ease;
    &-date {
      font-size: 12px;
      line-height: 14px;
      color: rgba(var(--black-color-rgba), 0.5);
      grid-row: 1;
      grid-column: 1 / span 3;
      transition: all 0.3s ease;
    }
    &-name-event {
      margin: auto 0;
      grid-row: 2;
      grid-column: 2;
      transition: all 0.3s ease;
    }
    &-name {
      font-weight: 500;
      padding-top: 5px;
      font-size: 14px;
      line-height: 18px;
      //grid-row: 2;
      //grid-column: 2;
    }
    &-event {
      text-decoration: underline;
      font-size: 14px;
      margin: auto 0;
    }
    .avatar {
      grid-row: 2;
      grid-column: 1;
      transition: all 0.3s ease;
    }

    @container (min-width:600px) {
      grid-template-rows: auto;
      grid-template-columns: 154px 36px 1fr;
      &-date {
        grid-column: 1;
        grid-row: 1;
                margin: auto auto auto 0;
      }
      .avatar {
        grid-column: 2;
        grid-row: 1;
      }
      &-name-event {
        grid-column: 3;
        grid-row: 1;
      }
    }
    @container (min-width:800px) {
      width: 70%;
      margin: 0 auto;
    }
  }
  &_body {
    display: flex;
    flex-wrap: wrap;
    @container (min-width:600px) {
      &-content,
      &-states {
        margin-top: 8px;
        padding-left: 162px !important;
      }
    }
    @container (min-width:800px) {
      width: 70%;
      margin: 0 auto;
    }
    &-content {
      width: 100%;
      padding-left: 40px;
      transition: all 0.3s ease;
    }
    &-reason {
      background: var(--color-main-green);
      border-radius: 0 25px 25px 25px;
      padding: 13px 15px 15px 15px;
      line-height: 18px;
      width: 100%;
      display: block;
    }
  }
  &_footer {
    @container (min-width:800px) {
      width: 70%;
      margin: 0 auto;
    }
  }
}
</style>
